import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=2995b1a2&"
import script from "./Packages.vue?vue&type=script&lang=js&"
export * from "./Packages.vue?vue&type=script&lang=js&"
import style0 from "./Packages.vue?vue&type=style&index=0&id=2995b1a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports